import service from './index'

const prefix = '/common-uam';

export const getSpecifyRelatedResourceList = (body: any):Promise<API.DataResponse<Record<string, any>[]>> => service.post(prefix + '/resources/specified/related-list', body);

export const getTenantSettings = (tenantId: string) =>
  service.get(`${prefix}/system-settings/tenant-settings`, {
    params: { tenantId },
  });

export const apiGetTenant = (id:string) => service.get(`/freyr-tm/tmSubscription/getByTenantId/${id}`);

export const apiGetESignSetting = (id:string) => service.get(`/freyr-tm/tmSubscription/eSignSetting?tenantId=${id}&moduleName=Product`);
export const fetchFeatureFlag = (id:string):Promise<API.DataResponse<API.FeatureFlagsData>> => service.get(`/freyr-tm/tmTenant/feature-flags?tenantId=${id}&moduleId=7`);

export const getSystemFeatureFlag = (params: Record<string, unknown>) =>
  service.get(`/freyr-tm/tmTenant/feature-flags`, { params });